// call with await setStateAsync(<new state>, this)
export function setStateAsync(state, that) {
  if (!that) console.error("`this` not passed as second argument to setStateAsync");
  return new Promise((resolve) => { that.setState(state, resolve); });
}